import { useDispatch, useSelector } from "react-redux";
import { PAGES_ALLOWED_BEFORE_COOKIE_CONSENT } from "common/config";
import { appActions } from "common/redux/app/app.slice";
import { RootState } from "common/redux/core/root.reducer";
import CookieConsentService from "common/services/cookie-consent.service";

const useCookie = () => {
  const dispatch = useDispatch();
  const path = window.location.pathname;
  const showCookieConsent = useSelector(
    (state: RootState) => state.app.showCookieConsent
  );

  const canCurrentPageAppearBeforeCookieConsent =
    PAGES_ALLOWED_BEFORE_COOKIE_CONSENT.includes(path);

  const checkCookie = () => {
    const canShowModal = CookieConsentService.canShowCookieConsentModal();
    dispatch(appActions.showCookieConsentModal(canShowModal));
  };

  const handleAcceptAllCookies = () => {
    CookieConsentService.acceptAllCookies();
    dispatch(appActions.showCookieConsentModal(false));
  };

  const handleDeclineOptionalCookies = () => {
    CookieConsentService.declineOptionalCookies();
    dispatch(appActions.showCookieConsentModal(false));
  };

  return {
    checkCookie,
    showCookieConsent,
    canCurrentPageAppearBeforeCookieConsent,
    handleAcceptAllCookies,
    handleDeclineOptionalCookies
  };
};

export default useCookie;
